import React from "react"
import PropTypes from "prop-types"
import Image from "gatsby-image"
import { Link } from "gatsby"

import styled from "styled-components"
const Blog = ({ title, image, date, category, slug, body }) => {
  return (
    <Wrapper>
      <Link to={`/blogs/${slug}`}>
        <Article>
          {image && (
            <Image fluid={image.childImageSharp.fluid} className="blog-img" />
          )}
          <Card>
            <h4>{title}</h4>
            <p>{body.substring(0, 100).concat(" ...")}</p>
            <CardFooter>
              <span>{category}</span>
              <div>{date}</div>
            </CardFooter>
          </Card>
        </Article>
      </Link>
    </Wrapper>
  )
}

Blog.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
}

export default Blog

export const Wrapper = styled.article`
  display: block;
  margin: 0;
  margin-bottom: 2rem;
  background: ${({ theme }) => theme.body};
  border-radius: var(--radius);
  box-shadow: var(--light-shadow);
  transition: var(--transition);
  outline: none;
  overflow: hidden;
  border: 0 !important;

  & a {
    text-decoration: none;
    max-height: 100%;
    max-width: 100%;
    border: 0 !important;
  }

  & img {
    border-radius: var(--radius) var(--radius) 0 0;
    border: 0 !important;
  }
  &:hover {
    box-shadow: var(--dark-shadow);
    transform: scale(1.02);
    outline: none;
    overflow: hidden;
    border: 0 !important;
  }

  @media screen and (min-width: 576px) {
    & .blogs-center {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(368px, 1fr));
      column-gap: 2rem;
    }
    & .blog-img {
      height: 17.5rem;
    }
  }
  @media screen and (min-width: 850px) {
    & .blog-img {
      height: 13rem;
    }
  }
  @media screen and (max-width: 550px) {
    & .blog-img {
      height: 10rem;
    }
  }
  @media screen and (max-width: 350px) {
    & .blog-img {
      height: 8rem;
    }
  }
`

export const Article = styled.article`
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
`

export const Card = styled.article`
  display: grid;
  grid-template-rows: auto 1fr auto;
  padding: 1.5rem 1rem;
  background: ${({ theme }) => theme.contentBackground};

  & h4 {
    padding-right: 0;
    color: ${({ theme }) => theme.headerColor};
  }
`

export const CardFooter = styled.article`
  display: flex !important;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 0;
  box-sizing: border-bottom;

  & span {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2px 10px;
    max-width: 50%;
    margin-bottom: 0;
    font-weight: bold;
    background: ${({ theme }) => theme.tagBackground};
    color: ${({ theme }) => theme.tagColor};
    border-radius: var(--radius);
  }

  & div {
    max-width: 100%;
    /* display: inline-block; */
    color: ${({ theme }) => theme.tagColor};
    /* margin-right: 0.5rem;*/
    padding: 0.25rem 0.5rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 0.8rem;
    margin: 0;
    padding: 0;
    box-sizing: border-bottom;
  }
`
